import React, { useState } from 'react';
import EditorSettings from '@wix/da-ds/pkg/Icons/24x24/EditorSettings';
import DaVideoPopup from '../DaVideoPopup';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Edit = ({ editor })=>{
    const { t } = useTranslation('editor');
    const [showPopup, setShowPopup] = useState(false);
    const onSelect = (src)=>{
        editor.chain().focus().daVideoReplace({
            src
        }).run();
        setShowPopup(false);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showPopup && /*#__PURE__*/ React.createElement(DaVideoPopup, {
        onCancel: ()=>setShowPopup(false),
        onSubmit: onSelect
    }), /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:video:edit",
        icon: EditorSettings,
        onClick: ()=>setShowPopup(true),
        tooltipText: t('ext.video.button.edit'),
        "aria-label": t('ext.video.button.edit')
    }));
};
Edit.displayName = 'Edit';
export default Edit;

//# sourceMappingURL=Edit.js.map